@if (annotationsSupported && !hideMenuTriggerButton()) {
  <button
    [disabled]="disableMenu()"
    mat-icon-button
    [matTooltip]="'ANNOTATIONS_MENU' | transloco"
    [matMenuTriggerFor]="menu"
  >
    <mat-icon>drive_file_rename_outline</mat-icon>
  </button>
}

<mat-menu #menu="matMenu">
  <ng-template matMenuContent>
    <button mat-menu-item (click)="onClickToggleEdit()">
      <span>{{ toggleEditText() }}</span>
    </button>
    <mat-divider></mat-divider>
    <button
      mat-menu-item
      (click)="onClickCreateHighlightAnnotation($event)"
      aria-label="highlight"
    >
      {{ 'HIGHLIGHT' | transloco }}
    </button>
    <button mat-menu-item [matMenuTriggerFor]="stampMenu" aria-label="stamps">
      Stamp
    </button>
  </ng-template>
  <mat-menu #stampMenu="matMenu">
    <ng-template matMenuContent>
      @for (stamp of stamps$ | async; track stamp) {
        <button
          mat-menu-item
          [attr.aria-label]="stamp.text"
          (click)="onClickCreateStampAnnotation($event, stamp.text)"
        >
          {{ stamp.text }}
        </button>
      }
      <mat-divider></mat-divider>
      @for (customStamp of customStamps$ | async; track customStamp) {
        <button
          mat-menu-item
          [attr.aria-label]="customStamp"
          (click)="onClickCreateStampAnnotation($event, customStamp)"
        >
          {{ customStamp }}
        </button>
      }
      <button
        mat-menu-item
        aria-label="custom"
        (click)="onClickCreateStampAnnotation($event, 'CUSTOM')"
      >
        Custom
      </button>
    </ng-template>
  </mat-menu>
  <button
    mat-menu-item
    (click)="onClickCreateRedactionAnnotation($event)"
    aria-label="redact"
  >
    {{ 'REDACT' | transloco }}
  </button>
  <button
    mat-menu-item
    (click)="onClickCreateNoteAnnotation($event)"
    aria-label="note"
  >
    {{ 'NOTE' | transloco }}
  </button>
  <button
    mat-menu-item
    (click)="onClickCreateImageAnnotation($event)"
    aria-label="image"
  >
    {{ 'IMAGE' | transloco }}
  </button>
  <button
    mat-menu-item
    (click)="onClickCreateFreehandAnnotation($event)"
    aria-label="freehand"
  >
    {{ 'FREEHAND' | transloco }}
  </button>
  <button
    mat-menu-item
    (click)="onClickCreateLineAnnotation($event)"
    aria-label="line"
  >
    {{ 'LINE' | transloco }}
  </button>
  <button
    mat-menu-item
    (click)="onClickCreateEllipseAnnotation($event)"
    aria-label="ellipse"
  >
    {{ 'ELLIPSE' | transloco }}
  </button>
</mat-menu>
